import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
     
<NavLink to='/category/Interview question/9'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Permutation and combination</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />
<td>



<p class="pq">1) In what ways the letters of the word "RUMOUR" can be arranged?</p>
<ol class="pointsu">
<li className='list'>180</li>
<li className='list'>150</li>
<li className='list'>200</li>
<li className='list'>230</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The word RUMOUR consists of 6 words in which R and U are repeated twice.<br/>
Therefore, the required number of permutations = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q1.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/><br/>
Or, <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q1_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 180 </p>
<p>Hence, 180 words can be formed by arranging the word RUMOUR.</p>
</div> </Collapsible>
<br />

<p class="pq">2) In what ways the letters of the word "PUZZLE" can be arranged to form the different new words so that the vowels always come together?</p>
<ol class="pointsu">
<li className='list'>280</li>
<li className='list'>450</li>
<li className='list'>630</li>
<li className='list'>240</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The word PUZZLE has 6 different letters, but ATQ, the vowels should always come together.<br/>
Now, let the vowels UE as a single entity.<br/>
Therefore, the number of letters is PZZL = 4, and UE = 1<br/>
Since the total number of letters = 4+1 = 5<br/>
So the arrangement would be in <sup>5</sup>P<sub>5</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/>= <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q2_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/>= 5! = 5*4*3*2*1 = 120 ways.</p>
<h4 class="n">Note: we know that 0! = 1</h4>
<p>Now, the vowels UE can arrange in 2 different ways, i.e., <sup>2</sup>P<sub>2</sub> = 2! = 2*1 = 2 ways</p>
<p>Hence, the new words that can be formed = 120 *2 = 240.</p>
</div> </Collapsible>
<br />

<p class="pq">3) In what ways can a group of 6 boys and 2 girls be made out of the total of 7 boys and 3 girls?</p>
<ol class="pointsu">
<li className='list'>50</li> 
<li className='list'>120</li> 
<li className='list'>21</li> 
<li className='list'>20</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Answer with the explanation:</strong></p>
<p><strong>We know that</strong> <sup>n</sup>C<sub>r</sub> = <sup>n</sup>C<sub>(n-r)</sub></p>
<p>The combination of 6 boys out of 7 and 2 girls out of 3 can be represented as <sup>7</sup>C<sub>6</sub> + <sup>3</sup>C<sub>2</sub><br/>
<strong>Therefore, the required number of ways</strong> = <sup>7</sup>C<sub>6</sub> * <sup>3</sup>C<sub>2</sub> = <sup>7</sup>C(7-6) * <sup>3</sup>C<sub>(3-2)</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 21</p>
<p>Hence, in 21 ways the group of 6 boys and 2 girls can be made.</p>
</div> </Collapsible>
<br />

<p class="pq">4) Out of a group of 7 boys and 6 girls, five boys are selected to form a team so that at least 3 boys are there on the team. In how many ways can it be done? </p>
<ol class="pointsu">
<li className='list'>645</li>
<li className='list'>734</li>
<li className='list'>756</li>
<li className='list'>612</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Answer with the explanation:</strong></p>
<p>We may have 5 men only, 4 men and 1 woman, and 3 men and 2 women in the committee.</p>
<p>So, the combination will be </p>
<p>as we know that</p>
<p><sup>n</sup>C<sub>r</sub>= <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q4.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/></p> 
<p>So, (<sup>7</sup>C<sub>3</sub> * <sup>6</sup>C<sub>2</sub>) + (<sup>7</sup>C<sub>4</sub> * <sup>6</sup>C<sub>1</sub>) + (<sup>7</sup>C<sub>5</sub>)<br/>
Or, <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q4_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> + <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q4_3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> + <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q4_4.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/></p>
<p>Or, 525 +210+21 = 756</p>
<p>So, there are 756 ways to form a committee.</p>
</div> </Collapsible>
<br />

<p class="pq">5) A box contains 2 red balls, 3 black balls, and 4 white balls. Find the number of ways by which 3 balls can be drawn from the box in which at least 1 black ball should be present.</p>
<ol class="pointsu">
<li className='list'>64</li>
<li className='list'>48</li>
<li className='list'>32</li>
<li className='list'>96</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The possible combination could be (1 black ball and 2 non-black balls), (2 black balls and 1 non- black ball), and (only 3 black balls).</p>
<p>Therefore the required number of combinations = (<sup>3</sup>C<sub>1</sub> * <sup>6</sup>C<sub>2</sub>) + (<sup>3</sup>C<sub>2</sub> * <sup>6</sup>C<sub>1</sub>) + (<sup>3</sup>C<sub>3</sub>)<br/>
r,<img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q5.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> + <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q5_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> + <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q5_3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 45+18+1 = 64</p>
</div> </Collapsible>
<br />
<p class="pq">6) Out of 7 constants and 4 vowels, how many words of 3 constants and 2 vowels can be formed?</p>
<ol class="pointsu">
<li className='list'>21020</li>
<li className='list'>25200</li>
<li className='list'>10500</li>
<li className='list'>21400</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Answer with the explanation:</strong></p>
<p>We can combine 3 consonants and 2 vowels out of 7 consonants and 4 vowels in a way </p>
<p><sup>7</sup>C<sub>3</sub> * <sup>4</sup>C<sub>2</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q6.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 210</p>
<p>That means 210 groups having 3 consonants and 2 vowels.</p>
<p>Each group consists of 5 words that mean the possible arrangement of the letters is 5!</p>
<p>Or, 5! = 5*4*3*2*1 = 120 ways.</p>
<p>Therefore, the required number of words = 210*120 = 25200.</p>
</div> </Collapsible>
<br />

<p class="pq">7) How much 4-digit number can be formed from the digits 2, 3, 4, 5, 6, and 7 which are divisible by 5 in such a way that digits should not repeat.</p>
<ol class="pointsu">
<li className='list'>25</li>
<li className='list'>30</li>
<li className='list'>35</li>
<li className='list'>60</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Answer with the explanation:</strong></p>
<p>A number is divisible by 5 if the number ends with 0 or 5, but we don't have 0 in the given digits that means 5 should come at the unit place.</p>
<p>Now, one of the remaining 5 digits (2, 3, 4, 6, and 7) can come at the tens place.<br/>
Similarly, we can fill the hundreds place by one of the remaining 4 digits. <br/>
Therefore, the thousands place can be filled by one of the remaining 3 digits.<br/>
Hence, the required number of the numbers = 1*5*4*3 = 60. </p>
</div> </Collapsible>
<br />

<p class="pq">8) In what ways the letters of the word "CRICKET" can be arranged to form the different new words so that the vowels always come together? </p>
<ol class="pointsu">
<li className='list'>120</li>
<li className='list'>240</li>
<li className='list'>360</li>
<li className='list'>480</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The word CRICKET has 7 different letters, but ATQ, the vowels should always come together.<br/>
Now, let the vowels IE as a single entity.<br/>
Therefore, the number of letters is CRCKT = 5 in which C is repeated twice, and IE = 1<br/>
Since the total number of letters = 5+1 = 6<br/>
So the arrangement (permutation) would be = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q8.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q8_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 5*4*3= 60 ways.</p>
<h4 class="n">Note: Here 2! is taken in the denominator, because the letter C is repeated twice.</h4>
<p>Now, the vowels IE can be arranged in 2 different ways, i.e., <sup>2</sup>P<sub>2</sub> = 2! = 2*1 = 2 ways.</p>
<p>So, the new words that can be formed = 60*2 = 120. </p>
</div> </Collapsible>
<br />

<p class="pq">9) In what ways the letters of the word ?MACHINE? can be arranged so that the vowels occupy only the odd positions? </p>
<ol class="pointsu">
<li className='list'>212</li> 
<li className='list'>326</li> 
<li className='list'>576</li> 
<li className='list'>400</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The word machine consists of 7 letters in which there are 3 vowels and 4 consonants. <br/>
ATQ, the vowels A, I, E can be placed at any of the position out of 1, 3, 5, and 7.  <br/>
That means the number of ways to arrange the vowels = <sup>4</sup>P<sub>3</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q9.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q9_2.png" style={{margin:'5px 4px -12px 0px'}} alt="Apti Permutation and Combination"/>= 4*3*2*1 = 24</p>
<p>Similarly, the number of ways to arrange the consonants = <sup>4</sup>P<sub>4</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q9_3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 4*3*2*1 = 24</p>
<h4 class="n">Note: we know that 0! = 1 </h4>
<p>Therefore the required numbers of ways = 24*24 = 576 </p>
</div> </Collapsible>
<br />

<p class="pq">10) In what ways the letters of the word ?ACTORS? can arrange so that the vowels occupy only the even positions? </p>
<ol class="pointsu">
<li className='list'>212</li> 
<li className='list'>144</li> 
<li className='list'>576</li> 
<li className='list'>400</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Answer with the explanation:</strong></p>
<p>The word ACTORS consist of 6 letters in which there are 2 vowels and 4 consonants <br/>
ATQ, the vowels A, O can be placed at any of the position out of 2, 4, and 6. <br/>
That means the number of ways to arrange the vowels = <sup>3</sup>P<sub>2</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q10.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q10_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 3*2 = 6 ways  </p>
<p>Similarly, the number of ways to arrange the consonants = <sup>4</sup>P<sub>4</sub> = <img src="https://static.javatpoint.com/aptitude/images/permutation-and-combination-q10_3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Permutation and Combination"/> = 4*3*2*1 = 24 ways</p>
<h4 class="n">Note: we know that 0! = 1</h4>
<p>Therefore the required numbers of ways = 6*24 = 144</p>
</div> </Collapsible>
<br />


<br/><br/>
</td>

        </div>
    )
}

export default Iq2
